import { render, staticRenderFns } from "./CrmActions.vue?vue&type=template&id=193ebceb&scoped=true"
import script from "./CrmActions.vue?vue&type=script&lang=js"
export * from "./CrmActions.vue?vue&type=script&lang=js"
import style0 from "./CrmActions.vue?vue&type=style&index=0&id=193ebceb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193ebceb",
  null
  
)

export default component.exports